export const downloadBackupCodes = (codes: string[]) => {
    const blob = new Blob(
        [`Kervolt POS — Two-Factor Backup Codes\n\n${codes.join('\n')}\n`],
        { type: 'text/plain' }
    );
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'backup-codes.txt';
    link.click();
    URL.revokeObjectURL(url);
};

export const copyBackupCodes = (codes: string[]): Promise<void> => {
    return navigator.clipboard.writeText(codes.join('\n'));
};

export const printBackupCodes = (codes: string[]) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    printWindow.document.write(`
        <html>
            <head><title>Two-Factor Backup Codes</title></head>
            <body style="font-family: monospace; padding: 24px;">
                <h2 style="font-family: sans-serif;">Two-Factor Backup Codes</h2>
                <p style="font-family: sans-serif;">Each code can be used once. Store this somewhere safe.</p>
                <pre style="font-size: 16px; line-height: 1.6;">${codes.join('\n')}</pre>
            </body>
        </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};
